module.exports = __webpack_public_path__ + "img/trending-news-dark-2.76bf5b1c.jpg";